// The audio format this browser's MediaRecorder can actually record. Chrome / Firefox / Android:
// WebM (Opus). iPhone and Mac Safari: MP4 (AAC) - asking them for "audio/webm" made
// new MediaRecorder() throw, so the speaker check never recorded on iPhones. The backend
// (utils/audioConvert.js) converts either.
const AUDIO_TYPES = ["audio/webm;codecs=opus", "audio/webm", "audio/mp4;codecs=mp4a.40.2", "audio/mp4", "audio/aac"];

export const pickAudioMimeType = () => {
  if (typeof window === "undefined" || !window.MediaRecorder || typeof window.MediaRecorder.isTypeSupported !== "function") return "";
  return AUDIO_TYPES.find((type) => window.MediaRecorder.isTypeSupported(type)) || "";
};

// A MediaRecorder for the stream in a format the browser supports (its own default when none of
// ours is listed). Throws like the constructor does.
export const createAudioRecorder = (stream) => {
  const mimeType = pickAudioMimeType();
  return mimeType ? new MediaRecorder(stream, { mimeType }) : new MediaRecorder(stream);
};

// Blob type and file extension for what the recorder produced.
export const recordedAudioType = (recorder) => (recorder && recorder.mimeType) || pickAudioMimeType() || "audio/webm";
export const audioFileExtension = (type) => (/mp4|aac|m4a/i.test(type || "") ? "m4a" : "webm");
